module.exports = __webpack_public_path__ + "media/univerahealthcare-perks@md-b08f66c982833c5fc792e6bd027ec2c6.jpg";